import React from 'react';

/** Cómo se escribe el nombre. Una sola constante para no repetirlo. */
const NOMBRE = 'Raza Pro';

interface MarcaProps {
    /** Frase completa. El nombre de la marca se resalta donde aparezca. */
    children: string;
}

/**
 * Pinta «Raza Pro» en amarillo dentro de una frase, dejando el resto con el
 * color que herede del contenedor.
 *
 * Existe para que el acento caiga en la MARCA y no en el enunciado entero: en
 * el fold ese texto es el más grande que hay y, pintado todo de amarillo,
 * competiría con el CTA. Sobre el navy-850 de esa sección el amarillo da 8:1 y
 * el blanco 12:1, así que la decisión es de composición, no de legibilidad.
 *
 * Recibe la frase YA TRADUCIDA y la parte en torno al nombre, en vez de pedir
 * dos cadenas sueltas por idioma: el nombre no se traduce y cae en distinto
 * sitio según la lengua — «Raza Pro los reemplaza todos.» /
 * «Raza Pro replaces every one of them.» — así que partir aquí evita duplicar
 * cada frase en el diccionario solo para poder colorearla.
 */
const Marca: React.FC<MarcaProps> = ({ children }) => {
    const texto = String(children ?? '');
    const corte = texto.indexOf(NOMBRE);

    // Si la frase no lleva el nombre (traducción nueva, texto cambiado), se
    // devuelve tal cual: mejor sin resaltar que rota.
    if (corte === -1) return <>{texto}</>;

    const antes = texto.slice(0, corte);
    const despues = texto.slice(corte + NOMBRE.length);

    return (
        <>
            {antes}
            <span className="text-brand-400">{NOMBRE}</span>
            {despues}
        </>
    );
};

export default Marca;
